// 动态路由配置
import Home from "../views/home/Home.vue";
import UserAdd from "../views/user-manage/UserAdd.vue";
import UserList from "../views/user-manage/UserList.vue";
import ProductList from "../views/product-manage/ProductList.vue";
import NotFound from "../views/notfound/NotFound.vue";
import AssessList from "../views/consumption-manage/AssessList.vue";
import ConsumptionList from "../views/consumption-manage/ConsumptionList.vue";
import ThirdPartyInvokeLogList from "../views/consumption-manage/ThirdPartyInvokeLogList.vue";
import RefundList from "../views/refund-manage/RefundList.vue";
import ManualRefundList from "../views/refund-manage/ManualRefundList.vue";
import RechargeList from "../views/recharge-manage/RechargeList.vue";
import RechargeRecord from "../views/recharge-manage/RechargeRecord.vue";
import BrandList from "@/views/brand-manage/BrandList.vue";
import ManufacturerPriceList from "@/views/brand-manage/ManufacturerPriceList.vue";
import ReportManage from "@/views/report-manage/index.vue";
import OpenApiAppList from "@/views/openapi-manage/AppList.vue";
import ProductAuthList from "@/views/openapi-manage/ProductAuthList.vue";
import OpenOrderList from "@/views/openapi-manage/OpenOrderList.vue";
import CallRecordList from "@/views/openapi-manage/CallRecordList.vue";
import BalanceList from "@/views/openapi-manage/BalanceList.vue";
import StatementSummary from "@/views/openapi-manage/StatementSummary.vue";
import InterfaceConfigList from "@/views/openapi-manage/InterfaceConfigList.vue";
import MenuList from "@/views/system-manage/MenuList.vue";
import DictList from "@/views/system-manage/DictList.vue";

const routersConfig = [
    {
        path: "/",
        redirect: "/dashboard"
    },
    {
        path: "/dashboard",
        component: Home,
        meta: { title: "\u9996\u9875" },
    },
    {
        path: "/userManage/userAdd",
        component: UserAdd,
        meta: { title: "\u65b0\u589e\u7528\u6237" },
    },
    {
        path: "/userManage/userList",
        component: UserList,
        meta: { title: "\u7528\u6237\u5217\u8868" },
    },
    {
        path: "/consumptionManage/assessList",
        component: AssessList,
        meta: { title: "\u8bc4\u4f30\u8bb0\u5f55" },
    },
    {
        path: "/consumptionManage/consumptionList",
        component: ConsumptionList,
        meta: { title: "\u8ba2\u5355\u8bb0\u5f55" },
    },
    {
        path: "/consumptionManage/thirdPartyInvokeLog",
        component: ThirdPartyInvokeLogList,
        meta: { title: "\u7b2c\u4e09\u65b9\u8c03\u7528\u65e5\u5fd7" },
    },
    {
        path: "/refundManage/refundList",
        component: RefundList,
        meta: { title: "\u9000\u6b3e\u8bb0\u5f55" },
    },
    {
        path: "/refundManage/manualRefundList",
        component: ManualRefundList,
        meta: { title: "\u624b\u52a8\u9000\u6b3e" },
    },
    {
        path: "/rechargeManage/rechargeList",
        component: RechargeList,
        meta: { title: "\u7528\u6237\u5145\u503c" },
    },
    {
        path: "/rechargeManage/rechargeRecord",
        component: RechargeRecord,
        meta: { title: "\u5145\u503c\u8bb0\u5f55" },
    },
    {
        path: "/brandManage/brandList",
        component: BrandList,
        meta: { title: "\u5e38\u7528\u54c1\u724c\u7ba1\u7406" },
    },
    {
        path: "/brandManage/manufacturerPriceList",
        component: ManufacturerPriceList,
        meta: { title: "\u7ef4\u4fdd\u54c1\u724c\u4ef7\u683c" },
    },
    {
        path: "/productManage/productList",
        component: ProductList,
        meta: { title: "\u4ea7\u54c1\u7ef4\u62a4" },
    },
    {
        path: "/reportManage/index",
        component: ReportManage,
        meta: { title: "\u62a5\u8868\u7ba1\u7406" },
    },
    {
        path: "/reportManage/view/:reportId",
        component: ReportManage,
        props: true,
        meta: { title: "\u4e1a\u52a1\u62a5\u8868" },
    },
    {
        path: "/openapiManage/appList",
        component: OpenApiAppList,
        meta: { title: "\u5e94\u7528\u7ba1\u7406" },
    },
    {
        path: "/openapiManage/productAuthList",
        component: ProductAuthList,
        meta: { title: "\u4ea7\u54c1\u6388\u6743" },
    },
    {
        path: "/openapiManage/interfaceConfig",
        component: InterfaceConfigList,
        meta: { title: "接口配置" },
    },
    {
        path: "/openapiManage/openOrderList",
        component: OpenOrderList,
        meta: { title: "\u5f00\u653e\u8ba2\u5355" },
    },
    {
        path: "/openapiManage/callRecordList",
        component: CallRecordList,
        meta: { title: "\u8c03\u7528\u65e5\u5fd7" },
    },
    {
        path: "/openapiManage/balanceList",
        component: BalanceList,
        meta: { title: "\u4f59\u989d\u7ba1\u7406" },
    },
    {
        path: "/openapiManage/statementSummary",
        component: StatementSummary,
        meta: { title: "\u5bf9\u8d26\u7edf\u8ba1" },
    },
    {
        path: "/systemManage/menuList",
        component: MenuList,
        meta: { title: "\u83dc\u5355\u7ba1\u7406" },
    },
    {
        path: "/systemManage/dictList",
        component: DictList,
        meta: { title: "\u5b57\u5178\u7ba1\u7406" },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "notFound",
        component: NotFound
    },
];

export default routersConfig;